import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { Lines, Reveal } from "./Motion";

const STEPS = [
  { t: "Site walk & estimate", d: "We come out, measure, listen and talk through options, then send a clear written estimate with no vague allowances." },
  { t: "Design & 3D plan", d: "Layouts, materials and colors worked out on a plan you can actually see, so there are no surprises when the lumber shows up." },
  { t: "Permits & scheduling", d: "We coordinate permits and inspections with the local offices and lock in a start date you can plan around." },
  { t: "Build & final walk", d: "A dedicated crew lead on site every day. We finish with a walkthrough and don't leave until it's right." },
];

export const Process = () => {
  const list = useRef(null);
  const { scrollYProgress } = useScroll({ target: list, offset: ["start 70%", "end 60%"] });

  return (
    <section id="process" data-testid="section-process" className="relative bg-[#F2F1ED] px-5 py-28 text-[#0A0A0A] md:px-10 md:py-40">
      <div className="mx-auto grid max-w-[1500px] gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <div className="flex items-center gap-3 font-mono text-[0.72rem] uppercase tracking-[0.25em] text-[#0A0A0A]"><span className="h-px w-8 bg-[#0A0A0A]" />How it works</div>
            <h2 className="mt-6 font-display text-4xl font-bold leading-[1] tracking-tighter md:text-6xl">
              <Lines lines={["Four steps.", "Zero guesswork."]} />
            </h2>
            <p className="mt-6 max-w-sm text-[#0A0A0A]/65">From the first site visit to the final walkthrough, you always know what's happening, who's on site and what's next.</p>
          </div>
        </div>
        <div ref={list} className="relative lg:col-span-6 lg:col-start-7">
          <div className="absolute bottom-0 left-[1.1rem] top-0 w-px bg-[#0A0A0A]/15" />
          <motion.div style={{ scaleY: scrollYProgress }} className="absolute bottom-0 left-[1.1rem] top-0 w-px origin-top bg-[#0A0A0A]" />
          <div className="space-y-20">
            {STEPS.map((s, i) => (
              <Reveal key={s.t} className="relative pl-16" delay={0.05}>
                <span data-testid={`process-step-${i + 1}`} className="absolute left-0 top-0 flex h-9 w-9 items-center justify-center rounded-full border border-[#0A0A0A]/20 bg-[#F2F1ED] font-mono text-xs">{`0${i + 1}`}</span>
                <h3 className="font-display text-3xl font-bold tracking-tight md:text-4xl">{s.t}</h3>
                <p className="mt-4 max-w-md text-base leading-relaxed text-[#0A0A0A]/70">{s.d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
